export default {
  setGroups: (state, payload) => {
    state.groups = payload;
  },
  setTotalItems: (state, payload) => {
    state.totalGroups = payload;
  },
  setProductSearch: (state, payload) => {
    if (payload.query) {
      state.productSearch.query = payload.query;
    }
    state.productSearch.selected = payload.selected;
    state.productSearch.items = payload.items;
    state.productSearch.loading = payload.loading;
  },
  setProductSearchLoading: (state, payload) => {
    state.productSearch.loading = payload;
  },
  setProductList: (state, payload) => {
    state.productList = payload;
  },
  setLoadingGroups: (state, payload) => {
    state.loadingGroups = payload;
  },
  setLoadingProducts: (state, payload) => {
    state.loadingProducts = payload;
  },
};
